"use client";

import { c as _c } from "react/compiler-runtime";
import { AlignHorizontalJustifyCenterIcon, AlignHorizontalJustifyEndIcon, AlignHorizontalJustifyStartIcon, AlignVerticalJustifyCenterIcon, AlignVerticalJustifyEndIcon, AlignVerticalJustifyStartIcon, ChevronsLeftRightEllipsis, GalleryHorizontal, Plus, RectangleHorizontalIcon, Trash2Icon } from "lucide-react";
import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { StoreBuilderUpload } from "@/ui/admin/store-builder/store-builder-upload";
import { debounce } from "@/ui/hooks/use-debounced-value";
import { Label } from "@/ui/shadcn/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui/shadcn/select";
import { TailwindColorPicker } from "@/ui/tailwind-color-picker";
import { BuilderInputField } from "@/ui/yns-components/builder-input-field";
import { CompactButtonGroup } from "../../shared/compact-button-group";
export const HeroSectionForm = t0 => {
  const $ = _c(106);
  const {
    data,
    theme
  } = t0;
  const context = useStoreBuilderContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      value: "fixed-width",
      icon: <GalleryHorizontal className="size-3" />,
      tooltip: "Fixed width"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [t1, {
      value: "full-width",
      icon: <ChevronsLeftRightEllipsis className="size-3" />,
      tooltip: "Full width"
    }];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const boxAlignmentOptions = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      value: "16/9",
      icon: <RectangleHorizontalIcon className="size-3 scale-x-75" />,
      tooltip: "16:9"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      value: "21/9",
      icon: <RectangleHorizontalIcon className="size-3" />,
      tooltip: "21:9"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [t3, t4, {
      value: "32/9",
      icon: <RectangleHorizontalIcon className="size-3 scale-x-125" />,
      tooltip: "32:9"
    }];
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const aspectRatioOptions = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      value: "left",
      icon: <AlignHorizontalJustifyStartIcon className="size-3" />,
      tooltip: "Align left"
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      value: "center",
      icon: <AlignHorizontalJustifyCenterIcon className="size-3" />,
      tooltip: "Align center"
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [t6, t7, {
      value: "right",
      icon: <AlignHorizontalJustifyEndIcon className="size-3" />,
      tooltip: "Align right"
    }];
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const horizontalAlignmentOptionsForSlides = t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      value: "top",
      icon: <AlignVerticalJustifyStartIcon className="size-3" />,
      tooltip: "Top"
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      value: "middle",
      icon: <AlignVerticalJustifyCenterIcon className="size-3" />,
      tooltip: "Middle"
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [t9, t10, {
      value: "bottom",
      icon: <AlignVerticalJustifyEndIcon className="size-3" />,
      tooltip: "Bottom"
    }];
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const verticalAlignmentOptionsForSlides = t11;
  let t12;
  if ($[11] !== data) {
    t12 = "slides" in data ? data.slides ?? [] : [data];
    $[11] = data;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const initialSlides = t12;
  const [slides, setSlides] = useState(initialSlides);
  let t13;
  if ($[13] !== context || $[14] !== slides) {
    t13 = () => {
      const newSlides = [...slides, {
        content: {
          type: "doc",
          content: [{
            type: "heading",
            attrs: {
              level: 2
            },
            content: [{
              type: "text",
              text: "Enter your title here"
            }]
          }, {
            type: "paragraph",
            content: [{
              type: "text",
              text: "Enter your description here..."
            }]
          }]
        },
        image: {
          src: "",
          alt: ""
        },
        button: {
          label: "",
          path: ""
        },
        objectPositionHorizontal: "center",
        objectPositionVertical: "center"
      }];
      setSlides(newSlides);
      context.saveSelectedPageSectionField({
        fieldPath: "slides",
        value: newSlides
      });
    };
    $[13] = context;
    $[14] = slides;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const addSlide = t13;
  let t14;
  if ($[16] !== context || $[17] !== slides) {
    t14 = index => {
      if (slides.length <= 1) {
        return;
      }
      const newSlides_0 = slides.filter((_, i) => i !== index);
      setSlides(newSlides_0);
      context.saveSelectedPageSectionField({
        fieldPath: "slides",
        value: newSlides_0
      });
    };
    $[16] = context;
    $[17] = slides;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const removeSlide = t14;
  let T0;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  if ($[19] !== addSlide || $[20] !== context || $[21] !== data || $[22] !== removeSlide || $[23] !== slides) {
    const updateSlideField = (index_0, fieldPath, value, t22) => {
      const save = t22 === undefined ? true : t22;
      const newSlides_1 = [...slides];
      const pathParts = fieldPath.split(".");
      let current = newSlides_1[index_0];
      for (let i_0 = 0; i_0 < pathParts.length - 1; i_0++) {
        console.log({
          current,
          pathPart: pathParts[i_0]
        });
        if (!current) {
          return;
        }
        const cursor = pathParts[i_0];
        if (!cursor) {
          return;
        }
        if (!current[cursor]) {
          current[cursor] = {};
        }
        current = current[cursor];
      }
      current[pathParts[pathParts.length - 1]] = value;
      setSlides(newSlides_1);
      if (save) {
        context.saveSelectedPageSectionField({
          fieldPath: "slides",
          value: newSlides_1
        });
      }
    };
    t20 = "space-y-6";
    let t23;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = <div className="text-sm font-semibold text-neutral-900 mb-3 pb-2 border-b border-neutral-200">{"Layout & Display"}</div>;
      $[32] = t23;
    } else {
      t23 = $[32];
    }
    let t24;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <span className="text-xs text-neutral-600 font-medium">Width</span>;
      $[33] = t24;
    } else {
      t24 = $[33];
    }
    const t25 = ("size" in data ? data.size : null) ?? "fixed-width";
    let t26;
    if ($[34] !== context) {
      t26 = value_0 => {
        context.saveSelectedPageSectionField({
          fieldPath: "size",
          value: value_0
        });
      };
      $[34] = context;
      $[35] = t26;
    } else {
      t26 = $[35];
    }
    let t27;
    if ($[36] !== t25 || $[37] !== t26) {
      t27 = <div className="grid gap-1">{t24}<CompactButtonGroup options={boxAlignmentOptions} defaultValue={t25} onValueChange={t26} className="w-full" /></div>;
      $[36] = t25;
      $[37] = t26;
      $[38] = t27;
    } else {
      t27 = $[38];
    }
    let t28;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = <span className="text-xs text-neutral-600 font-medium">Aspect Ratio</span>;
      $[39] = t28;
    } else {
      t28 = $[39];
    }
    const t29 = ("aspectRatio" in data ? data.aspectRatio : null) ?? "16/9";
    let t30;
    if ($[40] !== context) {
      t30 = value_1 => {
        context.saveSelectedPageSectionField({
          fieldPath: "aspectRatio",
          value: value_1
        });
      };
      $[40] = context;
      $[41] = t30;
    } else {
      t30 = $[41];
    }
    let t31;
    if ($[42] !== t29 || $[43] !== t30) {
      t31 = <div className="grid gap-1">{t28}<CompactButtonGroup options={aspectRatioOptions} defaultValue={t29} onValueChange={t30} className="w-full" /></div>;
      $[42] = t29;
      $[43] = t30;
      $[44] = t31;
    } else {
      t31 = $[44];
    }
    if ($[45] !== t27 || $[46] !== t31) {
      t21 = <div>{t23}<div className="space-y-4"><div className="grid grid-cols-2 gap-2">{t27}{t31}</div></div></div>;
      $[45] = t27;
      $[46] = t31;
      $[47] = t21;
    } else {
      t21 = $[47];
    }
    let t32;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
      t32 = <div className="text-sm font-semibold text-neutral-900">Slides</div>;
      $[48] = t32;
    } else {
      t32 = $[48];
    }
    let t33;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
      t33 = <Plus className="h-3 w-3 mr-1" />;
      $[49] = t33;
    } else {
      t33 = $[49];
    }
    if ($[50] !== addSlide) {
      t19 = <div className="flex items-center justify-between mb-3 pb-2 border-b border-neutral-200">{t32}<Button variant="outline" size="sm" className="h-7 px-2 text-xs" onClick={addSlide}>{t33}Add Slide</Button></div>;
      $[50] = addSlide;
      $[51] = t19;
    } else {
      t19 = $[51];
    }
    t18 = "space-y-4";
    T0 = Accordion;
    t15 = "multiple";
    t16 = "w-full space-y-3";
    t17 = slides.map((slide, index_1) => <AccordionItem key={index_1} value={`slide-${index_1}`} className="border rounded-md bg-white"><AccordionTrigger className="flex items-center bg-neutral-50 p-3 hover:no-underline rounded-t-md"><h4 className="text-sm font-medium text-neutral-900">Slide {index_1 + 1}</h4></AccordionTrigger><AccordionContent><div className="p-4 space-y-6"><div className="grid grid-cols-2 gap-2"><div className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Horizontal Alignment</span><CompactButtonGroup options={horizontalAlignmentOptionsForSlides} defaultValue={slide.boxAlignment} onValueChange={value_2 => updateSlideField(index_1, "boxAlignment", value_2)} className="w-full" /></div><div className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Vertical Alignment</span><CompactButtonGroup options={verticalAlignmentOptionsForSlides} defaultValue={slide.alignmentVertical} onValueChange={value_3 => updateSlideField(index_1, "alignmentVertical", value_3)} className="w-full" /></div></div><div className="grid gap-2 lg:grid-cols-1"><Label className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Background Color</span><TailwindColorPicker defaultValue={slide.theme?.backgroundColor ?? undefined} onValueChange={debounce(value_4 => {
                updateSlideField(index_1, "theme.backgroundColor", value_4 ?? "");
              }, 300, {
                trailing: true
              })} /></Label></div><div><h5 className="text-sm font-medium text-neutral-900 mb-3 pb-2 border-b border-neutral-200">Image/Video</h5><div className="space-y-4"><div className="text-xs text-neutral-600">Images: PNG, JPG, WebP, AVIF ⋅ Videos: MP4, WebM, OGG ⋅ Dimensions: 1920x1080 (16:9) ⋅ Max size: 25 MB</div><StoreBuilderUpload width={1920} height={1080} className="" fieldPathPrefix={`slides.${index_1}.image.`} images={[slide.image?.src].filter(Boolean)} acceptVideo={true} onUpload={src => {
                updateSlideField(index_1, "image.src", src, false);
              }} onDelete={() => {
                updateSlideField(index_1, "image.src", "", false);
              }} /><div className="grid grid-cols-2 gap-2"><div className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Horizontal Alignment</span><CompactButtonGroup options={[{
                    value: "left",
                    icon: <AlignHorizontalJustifyStartIcon className="size-3" />,
                    tooltip: "Left"
                  }, {
                    value: "center",
                    icon: <AlignHorizontalJustifyCenterIcon className="size-3" />,
                    tooltip: "Center"
                  }, {
                    value: "right",
                    icon: <AlignHorizontalJustifyEndIcon className="size-3" />,
                    tooltip: "Right"
                  }]} defaultValue={slide.objectPositionHorizontal ?? "center"} onValueChange={value_5 => updateSlideField(index_1, "objectPositionHorizontal", value_5)} className="w-full" /></div><div className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Vertical Alignment</span><CompactButtonGroup options={[{
                    value: "top",
                    icon: <AlignVerticalJustifyStartIcon className="size-3" />,
                    tooltip: "Top"
                  }, {
                    value: "center",
                    icon: <AlignVerticalJustifyCenterIcon className="size-3" />,
                    tooltip: "Center"
                  }, {
                    value: "bottom",
                    icon: <AlignVerticalJustifyEndIcon className="size-3" />,
                    tooltip: "Bottom"
                  }]} defaultValue={slide.objectPositionVertical ?? "center"} onValueChange={value_6 => updateSlideField(index_1, "objectPositionVertical", value_6)} className="w-full" /></div></div></div></div><div><h5 className="text-sm font-medium text-neutral-900 mb-3 pb-2 border-b border-neutral-200">Buttons</h5><div className="space-y-6"><div className="space-y-4"><div className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Button Alignment</span><CompactButtonGroup options={[{
                    value: "left",
                    icon: <AlignHorizontalJustifyStartIcon className="size-3" />,
                    tooltip: "Left"
                  }, {
                    value: "center",
                    icon: <AlignHorizontalJustifyCenterIcon className="size-3" />,
                    tooltip: "Center"
                  }, {
                    value: "right",
                    icon: <AlignHorizontalJustifyEndIcon className="size-3" />,
                    tooltip: "Right"
                  }]} defaultValue={slide.textAlignment ?? "left"} onValueChange={value_7 => updateSlideField(index_1, "textAlignment", value_7)} className="w-full" /></div><div className="grid grid-cols-2 gap-2"><div className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Button Radius</span><Select defaultValue={slide.theme?.buttonRadius ?? "full"} onValueChange={debounce(value_8 => {
                      updateSlideField(index_1, "theme.buttonRadius", value_8 ?? "full");
                    }, 300, {
                      trailing: true
                    })}><SelectTrigger className="w-full"><SelectValue placeholder="Select radius" /></SelectTrigger><SelectContent><SelectItem value="none">None</SelectItem><SelectItem value="sm">Small</SelectItem><SelectItem value="md">Medium</SelectItem><SelectItem value="lg">Large</SelectItem><SelectItem value="full">Full</SelectItem></SelectContent></Select></div><div className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Button Border</span><Select defaultValue={slide.theme?.buttonBorder ?? "none"} onValueChange={debounce(value_9 => {
                      updateSlideField(index_1, "theme.buttonBorder", value_9 ?? "none");
                    }, 300, {
                      trailing: true
                    })}><SelectTrigger className="w-full"><SelectValue placeholder="Select border" /></SelectTrigger><SelectContent><SelectItem value="none">None</SelectItem><SelectItem value="sm">Small</SelectItem><SelectItem value="md">Medium</SelectItem><SelectItem value="lg">Large</SelectItem></SelectContent></Select></div></div></div><Accordion type="multiple" className="w-full"><AccordionItem value={`slide-${index_1}-primary-button`} className="border-none"><AccordionTrigger className="py-2 text-sm font-medium">Primary Button</AccordionTrigger><AccordionContent><div className="space-y-4 pt-2"><BuilderInputField label="Button Label" defaultValue={slide.button?.label ?? ""} onValueChange={value_10 => updateSlideField(index_1, "button.label", value_10)} /><BuilderInputField label="Button Link" defaultValue={slide.button?.path ?? ""} onValueChange={value_11 => updateSlideField(index_1, "button.path", value_11)} /><div className="grid gap-2 lg:grid-cols-2"><Label className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Button Background</span><TailwindColorPicker defaultValue={slide.theme?.buttonBackgroundColor ?? undefined} onValueChange={debounce(value_12 => {
                            updateSlideField(index_1, "theme.buttonBackgroundColor", value_12 ?? "");
                          }, 300, {
                            trailing: true
                          })} /></Label><Label className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Button Text Color</span><TailwindColorPicker defaultValue={slide.theme?.buttonTextColor ?? undefined} onValueChange={debounce(value_13 => {
                            updateSlideField(index_1, "theme.buttonTextColor", value_13 ?? "");
                          }, 300, {
                            trailing: true
                          })} /></Label><Label className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Button Hover Background</span><TailwindColorPicker defaultValue={slide.theme?.buttonHoverBackgroundColor ?? undefined} onValueChange={debounce(value_14 => {
                            updateSlideField(index_1, "theme.buttonHoverBackgroundColor", value_14 ?? "");
                          }, 300, {
                            trailing: true
                          })} /></Label><Label className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Button Border Color</span><TailwindColorPicker defaultValue={slide.theme?.buttonBorderColor ?? undefined} onValueChange={debounce(value_15 => {
                            updateSlideField(index_1, "theme.buttonBorderColor", value_15 ?? "");
                          }, 300, {
                            trailing: true
                          })} /></Label></div></div></AccordionContent></AccordionItem><AccordionItem value={`slide-${index_1}-secondary-button`} className="border-none"><AccordionTrigger className="py-2 text-sm font-medium">Secondary Button</AccordionTrigger><AccordionContent><div className="space-y-4 pt-2"><BuilderInputField label="Button Label" defaultValue={slide.button2?.label ?? ""} onValueChange={value_16 => updateSlideField(index_1, "button2.label", value_16)} /><BuilderInputField label="Button Link" defaultValue={slide.button2?.path ?? ""} onValueChange={value_17 => updateSlideField(index_1, "button2.path", value_17)} /><div className="grid gap-2 lg:grid-cols-2"><Label className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Button Background</span><TailwindColorPicker defaultValue={slide.theme?.button2BackgroundColor ?? undefined} onValueChange={debounce(value_18 => {
                            updateSlideField(index_1, "theme.button2BackgroundColor", value_18 ?? "");
                          }, 300, {
                            trailing: true
                          })} /></Label><Label className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Button Text Color</span><TailwindColorPicker defaultValue={slide.theme?.button2TextColor ?? undefined} onValueChange={debounce(value_19 => {
                            updateSlideField(index_1, "theme.button2TextColor", value_19 ?? "");
                          }, 300, {
                            trailing: true
                          })} /></Label><Label className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Button Hover Background</span><TailwindColorPicker defaultValue={slide.theme?.button2HoverBackgroundColor ?? undefined} onValueChange={debounce(value_20 => {
                            updateSlideField(index_1, "theme.button2HoverBackgroundColor", value_20 ?? "");
                          }, 300, {
                            trailing: true
                          })} /></Label><Label className="grid gap-1"><span className="text-xs text-neutral-600 font-medium">Button Border Color</span><TailwindColorPicker defaultValue={slide.theme?.button2BorderColor ?? undefined} onValueChange={debounce(value_21 => {
                            updateSlideField(index_1, "theme.button2BorderColor", value_21 ?? "");
                          }, 300, {
                            trailing: true
                          })} /></Label></div></div></AccordionContent></AccordionItem></Accordion></div></div>{slides.length > 1 && <Button variant="outline" size="sm" onClick={() => removeSlide(index_1)} className="w-full bg-red-50 border-red-200 text-red-700 hover:bg-red-100 hover:border-red-300"><Trash2Icon className="h-4 w-4 mr-2" />Remove Slide</Button>}</div></AccordionContent></AccordionItem>);
    $[19] = addSlide;
    $[20] = context;
    $[21] = data;
    $[22] = removeSlide;
    $[23] = slides;
    $[24] = T0;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
    $[29] = t19;
    $[30] = t20;
    $[31] = t21;
  } else {
    T0 = $[24];
    t15 = $[25];
    t16 = $[26];
    t17 = $[27];
    t18 = $[28];
    t19 = $[29];
    t20 = $[30];
    t21 = $[31];
  }
  let t22;
  if ($[52] !== T0 || $[53] !== t15 || $[54] !== t16 || $[55] !== t17) {
    t22 = <T0 type={t15} className={t16}>{t17}</T0>;
    $[52] = T0;
    $[53] = t15;
    $[54] = t16;
    $[55] = t17;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== t18 || $[58] !== t22) {
    t23 = <div className={t18}>{t22}</div>;
    $[57] = t18;
    $[58] = t22;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  let t24;
  if ($[60] !== t19 || $[61] !== t23) {
    t24 = <div>{t19}{t23}</div>;
    $[60] = t19;
    $[61] = t23;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  let t25;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="text-sm font-medium text-neutral-800 mb-3 pb-2 border-b border-neutral-200">Global Theme Settings</div>;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <p className="text-sm text-neutral-600 mb-4">Default theme values used by slides unless overridden</p>;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <span className="text-xs text-neutral-600 font-medium">Background Color</span>;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  const t28 = theme?.backgroundColor;
  let t29;
  if ($[66] !== context) {
    t29 = debounce(value_22 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "backgroundColor",
        value: value_22
      });
    }, 300, {
      trailing: true
    });
    $[66] = context;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== t28 || $[69] !== t29) {
    t30 = <Label className="grid gap-1">{t27}<TailwindColorPicker defaultValue={t28} onValueChange={t29} /></Label>;
    $[68] = t28;
    $[69] = t29;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  let t31;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <span className="text-xs text-neutral-600 font-medium">Font Color</span>;
    $[71] = t31;
  } else {
    t31 = $[71];
  }
  const t32 = theme?.color;
  let t33;
  if ($[72] !== context) {
    t33 = debounce(value_23 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "color",
        value: value_23
      });
    }, 300, {
      trailing: true
    });
    $[72] = context;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] !== t32 || $[75] !== t33) {
    t34 = <Label className="grid gap-1">{t31}<TailwindColorPicker defaultValue={t32} onValueChange={t33} /></Label>;
    $[74] = t32;
    $[75] = t33;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  let t35;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <span className="text-xs text-neutral-600 font-medium">Button Background</span>;
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  const t36 = theme?.buttonBackgroundColor;
  let t37;
  if ($[78] !== context) {
    t37 = debounce(value_24 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "buttonBackgroundColor",
        value: value_24
      });
    }, 300, {
      trailing: true
    });
    $[78] = context;
    $[79] = t37;
  } else {
    t37 = $[79];
  }
  let t38;
  if ($[80] !== t36 || $[81] !== t37) {
    t38 = <Label className="grid gap-1">{t35}<TailwindColorPicker defaultValue={t36} onValueChange={t37} /></Label>;
    $[80] = t36;
    $[81] = t37;
    $[82] = t38;
  } else {
    t38 = $[82];
  }
  let t39;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <span className="text-xs text-neutral-600 font-medium">Button Text Color</span>;
    $[83] = t39;
  } else {
    t39 = $[83];
  }
  const t40 = theme?.buttonTextColor;
  let t41;
  if ($[84] !== context) {
    t41 = debounce(value_25 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "buttonTextColor",
        value: value_25
      });
    }, 300, {
      trailing: true
    });
    $[84] = context;
    $[85] = t41;
  } else {
    t41 = $[85];
  }
  let t42;
  if ($[86] !== t40 || $[87] !== t41) {
    t42 = <Label className="grid gap-1">{t39}<TailwindColorPicker defaultValue={t40} onValueChange={t41} /></Label>;
    $[86] = t40;
    $[87] = t41;
    $[88] = t42;
  } else {
    t42 = $[88];
  }
  let t43;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <span className="text-xs text-neutral-600 font-medium">Button Hover Background</span>;
    $[89] = t43;
  } else {
    t43 = $[89];
  }
  const t44 = theme?.buttonHoverBackgroundColor;
  let t45;
  if ($[90] !== context) {
    t45 = debounce(value_26 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "buttonHoverBackgroundColor",
        value: value_26
      });
    }, 300, {
      trailing: true
    });
    $[90] = context;
    $[91] = t45;
  } else {
    t45 = $[91];
  }
  let t46;
  if ($[92] !== t44 || $[93] !== t45) {
    t46 = <Label className="grid gap-1">{t43}<TailwindColorPicker defaultValue={t44} onValueChange={t45} /></Label>;
    $[92] = t44;
    $[93] = t45;
    $[94] = t46;
  } else {
    t46 = $[94];
  }
  let t47;
  if ($[95] !== t30 || $[96] !== t34 || $[97] !== t38 || $[98] !== t42 || $[99] !== t46) {
    t47 = <div>{t25}<div className="space-y-4">{t26}<div className="grid gap-2 lg:grid-cols-2">{t30}{t34}{t38}{t42}{t46}</div></div></div>;
    $[95] = t30;
    $[96] = t34;
    $[97] = t38;
    $[98] = t42;
    $[99] = t46;
    $[100] = t47;
  } else {
    t47 = $[100];
  }
  let t48;
  if ($[101] !== t20 || $[102] !== t21 || $[103] !== t24 || $[104] !== t47) {
    t48 = <div className={t20}>{t21}{t24}{t47}</div>;
    $[101] = t20;
    $[102] = t21;
    $[103] = t24;
    $[104] = t47;
    $[105] = t48;
  } else {
    t48 = $[105];
  }
  return t48;
};